<template>
  <!-- <v-row
    v-debug -->
  <div
    v-if="baseDebug"
  >
    <VDialog
      v-bind="{
        //fullscreen: true,
      }"
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600px"
    >
      <template #default="{ isActive }">
        <div class="debug-dialog">
          <VToolbar
            color="primary"
            density="compact"
          >
            <VBtn
              icon="mdi-close"
              @click="dialog = false"
            >
            </VBtn>
            <VToolbarTitle>Debug Dialog</VToolbarTitle>
            <VSpacer />
          </VToolbar>
          <VListItem :title="'System Version:  '+version"></VListItem>
          <LetsDebugLogin @close-dialog="dialog = false"></LetsDebugLogin>
          <VList>
            <VListSubheader>Session Info</VListSubheader>
            <VCard>
              <VCardSubtitle>
                <div>id: {{ user.id }} </div>
                <div>user_id: {{ user.user_id }} </div>
                <div>user_no: {{ user.user_no }} </div>
                <div>role_code: {{ user.user_type_code }} </div>
                <div>student_no: {{ user.student_no }} </div>
                <div>teacher_no: {{ user.teacher_no }} </div>
                <VCheckbox
                  v-model="mockProduction"
                  label="MockProduction (Refresh to take effect)"
                  @update:model-value="toggleMockProduction"
                />
                <VCheckbox
                  v-model="hideDebugElement"
                  label="hideDebugElement (no need refresh) (ctrl + h)"
                  @update:model-value="toggleHideDebugElement"
                />
                <!-- <ChangeLanguageBtn /> -->
              </VCardSubtitle>
            </VCard>
          </VList>
          <VDivider />
          <VList v-if="true">
            <VListSubheader>General</VListSubheader>
            <VTextField
              id="search"
              v-model="searchKey"
              variant="outlined"
              label="Search"
              class="mx-auto col-6"
            />
            <VListItem
              v-for="(data,i) in filteredDatas"
              :key="data.title + i"
              :to="data.to"
              :title="data.title"
              :prepend-icon="data.icon"
              :subtitle="data.desc"
              @click="onClick(data)"
            />
          </VList>
        </div>
      </template>
    </VDialog>
  </div>
</template>

<script>
import ToggleMockProductionMixin from './ToggleMockProductionMixin'
import ChangeLanguageBtn from '../layouts/Header/ChangeLanguageBtn.vue';
import LetsDebugLogin from './LetsDebugLogin.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  components: { ChangeLanguageBtn,LetsDebugLogin },
  mixins: [ToggleMockProductionMixin],
  data () {
    return {
      dialog: false,
      searchKey: '',
      datas: [],
      searchDatas: [],
      isHighlighting : false
    }
  },
  computed: {
    ...mapGetters({
      user: 'Auth/getUser'
    }),
    filteredDatas () {
      return this.datas.filter((data) => {
        return data.search.includes(this.searchKey.toLowerCase())
      })
    },
    version () {
      return window.AppVersion || 'Unknown Version'
    },
  },
  watch: {
    dialog (val) {
      if (val) {
        this.$nextTick(() => {
          this.searchKey = ''
          // document.getElementById('search').focus()
          // console.log('focus')
        })
      }
    }
  },
  async created () {
    if(this.baseDebug) {
      // overwrite ctrl+p
      window.addEventListener('keydown', this.keydownHandler, false)

      this.datas = this.generate([
        {
          type: 'route',
          title: 'AllCompsExample',
          to: { name: 'AllCompsExample', query: { portal: 'admin' } }
        },
        {
          icon: 'mdi-logout',
          desc: '(Debug Logout) Click to logout',
          title: 'Logout',
          onClick (that, input) {
            that.$store.dispatch('Auth/Auth_logout')
          }
        },
        {
          type: 'login',
          title: 'Login as Admin (role 560)',
          input: {
            user_id: 'admin',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as Admin センター長 (role 550)',
          input: {
            user_id: 'admin550',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as Admin 事務スタッフ (role 540)',
          input: {
            user_id: 'admin540',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as Admin 担当者 (role 530)',
          input: {
            user_id: 'admin530',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as Admin 営業 (role 520)',
          input: {
            user_id: 'admin520',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as 教室(オンライン教室) 410',
          input: {
            user_id: 'classroom410',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as 教室（直営）420',
          input: {
            user_id: 'classroom420',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as 教室（FC）430',
          input: {
            user_id: 'classroom430',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as Teacher teacher0001 (role 300)',
          input: {
            user_id: 'teacher0001',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as student std0001 (role 120)',
          input: {
            user_id: 'std0001',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as 小学講師0001 (role 300)',
          input: {
            user_id: '小学講師0001',
            user_password: 'password'
          }
        },
        {
          type: 'login',
          title: 'Login as 小学生徒0001',
          input: {
            user_id: '小学生徒0001',
            user_password: 'password'
          }
        },

        // BUG
        ...this.$router.getRoutes().map((item) => {
          if (item.name === null || item.name === undefined) { return null }
          return {
            icon: 'mdi-link',
            desc: item.path + '(dynamic route may not work)',
            title: '[Auto Gen Route]' + item.name,
            onClick (that, input) {
              that.$router.push({ path: item.path })
            }
          }
        })
      ])
    }
  },
  methods: {
    ...mapActions('Auth', ['Auth_login', 'isPasswordExpired']),
    keydownHandler (e) {
      if (import.meta.env.VITE_NODE_ENV === 'production') return
      if (e.key === 'p' && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
        e.preventDefault()
        this.dialog = !this.dialog
      }
      if (e.key === 'h' && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
        e.preventDefault()
        this.hideDebugElement = !this.hideDebugElement
        this.toggleHideDebugElement(this.hideDebugElement)
        this.$dialog.notify.info('hideDebugElement: ' + this.hideDebugElement)
      }
      if (e.key === 'g' && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
        e.preventDefault()
        this.toggleWordHighlighting()
      }
    },
    generate (data) {
      // filter out null
      data = data.filter((item) => {
        return item !== null
      })
      return data.map((item) => {
        const { type, ...rest } = item
        const map = {
          route: {
            icon: 'mdi-link',
            desc: 'Click to go to route'
          },
          login: {
            icon: 'mdi-login',
            desc: '(Debug Login)Click to login as ',
            async onClick (that, input) {
              await that.$store.dispatch('Auth/Auth_login', input)
              that.$router.push({ name: 'Home' });
            }
          }
        }
        const res = {
          ...map[type],
          ...rest
        }
        return {
          ...res, search: JSON.stringify(res).toLowerCase()
        }
      })
    },
    onClick (data) {
      if (data.onClick) {
        data.onClick(this, data.input)
      }
    },
    toggleWordHighlighting(){
      // This script toggles highlighting of all elements with a font-size not equal to 16px and contain text
      this.isHighlighting = !this.isHighlighting; // Toggle the state

      if(this.isHighlighting) {
        this.$dialog.notify.info('Highlighting font-size equal to 14px');
      } else {
        this.$dialog.notify.error('Disable Highlighting font-size equal to 14px');
      }

      document.querySelectorAll('*').forEach(element => {
        const fontSize = window.getComputedStyle(element).fontSize;
        const hasText = element.textContent.trim().length > 0; // Check if the element contains text

        if (fontSize !== '12px' && hasText) {
          element.style.outline = this.isHighlighting ? '2px solid red' : ''; // Add or remove the red outline

          element.title = this.isHighlighting ? fontSize : ''; // Add tooltip
        }
      });

    }
  }
}
</script>

<style scoped>
.debug-dialog {
  max-height: 80vh;
  overflow-y: auto;
  background-color: white;
}
</style>
